import { rest } from 'msw';

import { getApiBaseUrl } from 'src/utils/configStore';

import { documentSectionRoute } from '../hooks/documents.api.hooks';

import { MOCK_RES } from './documents.api.mock.response';

const baseURL = getApiBaseUrl();
const delayDuration = 1000;

const documentsApiMocks = [
    rest.get(`${baseURL}${documentSectionRoute}`, async (req, res, ctx) => {
        return res(
            ctx.delay(delayDuration),
            ctx.status(200),
            ctx.json(MOCK_RES.Documents),
        );
    }),
];

export default documentsApiMocks;
